import * as PropTypes from 'prop-types';
import * as React from 'react';

var OptionalMessage = props => {
  var {
    message
  } = props;
  var optionalText = message || ' (optional)';
  return /*#__PURE__*/React.createElement("span", {
    className: "form-label-text-secondary"
  }, optionalText);
};
OptionalMessage.propTypes = {
  message: PropTypes.string
};

export { OptionalMessage };
